import React from "react";
import { Popup, List, Button } from "semantic-ui-react";
import ReactJson from 'react-json-view'
import XLSX from 'xlsx';
import AWS from "aws-sdk";

export function formatField(field, value, row=null)
{
    if("lookup" in field && "values" in field)
    {
        
        if ('filterfields' in field)
        {
            if(row)
            {
                const lookupkey=field.filterfields.map(fieldname=>{return row[fieldname]}).join('_')
                if (lookupkey in field.values)
                {
                    if (value in field.values[lookupkey])
                    {
                        return field.values[lookupkey][value]    
                    }
                }
            }
        }
        else
        {
            if(value in field.values)
            {
                return field.values[value];
            }
        }
        return ""   
    }
    switch(field['type'])
    {
        case "date":
            if(value) return formatDate(new Date(value));
            else return ""
        case "datetime":
            if(value) return formatDateTime(new Date(value));
            else return ""
        case "time":
            if(value) return formatTime(new Date(value));
            else return ""
        case "bit":
            if (value===true) return "True" 
            else if (value===false) return "False" 
            else return ""
        case "json":
            //if(value) return <Popup trigger={<Button icon='search'/>} wide><Popup.Header>Data Values</Popup.Header><Popup.Content><List>{Object.keys(value).map((key=>{if (value[key] !==null) return <List.Item>{key + " " + value[key]}</List.Item>}))}</List></Popup.Content></Popup>
            if(value) return <ReactJson src={value} name={false} collapsed={true} iconStyle="triangle" displayDataTypes={false} displayObjectSize={false} />
            else return ""
        default:
            return value
    }


}

export function formatDate(date) {
    var monthNames = [
      "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul",
      "Aug", "Sep", "Oct",
      "Nov", "Dec"
    ];
  
    var day = date.getDate();
    var monthIndex = date.getMonth();
    var year = date.getFullYear();
  
    return day + ' ' + monthNames[monthIndex] + ' ' + year;
  }

  export function formatTime(date) {
    var hour = date.getHours();
    var min = date.getMinutes();
    var sec = date.getSeconds();
  
    return ('00' + hour.toString()).slice(-2) + ':' + ('00' + min.toString()).slice(-2) + ':' + ('00' + sec.toString()).slice(-2);
  }

  export function formatDateTime(date) {
    return formatDate(date) +' ' + formatTime(date);
  }

  export function formatAddress (addressObject)
  {

    var addressLines=[]
    if(addressObject.subbuildingname) addressLines.push(addressObject.subbuildingname);
    if(addressObject.buildingname) addressLines.push(addressObject.buildingname);
    
    if(addressObject.buildingnumber) 
    {
      if(addressObject.dependentthoroughfare)
        {
          addressLines.push(addressObject.buildingnumber + ' ' + addressObject.dependentthoroughfare);
          if(addressObject.thoroughfare) addressLines.push(addressObject.thoroughfare);
        }
        else
        {
          addressLines.push(addressObject.buildingnumber + ' ' + addressObject.thoroughfare);
        }
    }
    else
    {
      addressLines.push(addressObject.thoroughfare);
    }
    if(addressObject.doubledependentlocality) addressLines.push(addressObject.doubledependentlocality);
    if(addressObject.dependentlocality ) addressLines.push(addressObject.dependentlocality);
    if(addressObject.posttown) addressLines.push(addressObject.posttown);
    if(addressObject.county) addressLines.push(addressObject.county);
    if(addressObject.postcode) addressLines.push(addressObject.postcode);
    return addressLines;

  }

  export function JSONDate(date) {
 
    var day = date.getDate();
    var month= date.getMonth()+1;
    var year = date.getFullYear();
  
    return year.toString()+'-'+('00'+month.toString()).slice(-2)+'-'+('00'+day.toString()).slice(-2);
  }
  
  export function JSONDateTime(date) {
 
    return JSONDate(date)+'T'+formatTime(date)
  }

  export function JSONMonth(date) {
 
    var month= date.getMonth()+1;
    var year = date.getFullYear();
  
    return year.toString()+'-'+('00'+month.toString()).slice(-2)
  }

  export function exporttocsv(headers, data, filename) {
    console.log(data)
    var csv = headers.join(',') + '\n';
    data.forEach(row=> {
            csv += row.join(',');
            csv += "\n";
    });
 
    var hiddenElement = document.createElement('a');
    hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
    hiddenElement.target = '_blank';
    hiddenElement.download = filename;
    hiddenElement.click();
}

export function convertLookupListtoObject(lookuplist) {
    return lookuplist.reduce((obj, item) => {
        obj[item.value] = item.text
        return obj
      }, {})
}


export function exportToExcel(data, fieldnames, headers, title) {
    var sheetdata=[]
    sheetdata.push(headers);
    data.map(row=>{
        const sheetrow=fieldnames.map(fieldname=>{return row[fieldname]});
        sheetdata.push(sheetrow);
    })
    console.log(sheetdata)
    var wb = XLSX.utils.book_new();
    var ws = XLSX.utils.aoa_to_sheet(sheetdata);
    XLSX.utils.book_append_sheet(wb, ws, title);
    XLSX.writeFile(wb, title+'.xlsx');
}

export function downloadTextFile (filecontent, filename)
{
    var hiddenElement = document.createElement('a');
    hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(filecontent);
    hiddenElement.target = '_blank';
    hiddenElement.download = filename;
    hiddenElement.click();

}


export function exportTableToExcel(table, title) {
    var headers=[];
    var data=[];
    Array.from(table.rows).forEach((row, i)=>{
        if (i===0)
        {
            Array.from(row.cells).forEach((header, j)=>{headers.push(header.innerText)})
        }
        else
        {
            var rowdata={};
            Array.from(row.cells).forEach((value, j)=>{rowdata[headers[j]]=value.innerText})
            data.push(rowdata)

        }
    })
    exportToExcel(data, headers, headers, title)
}

export function formatDateYYYYMMDD(date) {
 
  var day = date.getDate();
  var month= date.getMonth()+1;
  var year = date.getFullYear();

  return year.toString()+('00'+month.toString()).slice(-2)+('00'+day.toString()).slice(-2);
}

export function formatXml(xml, tab) { // tab = optional indent value, default is tab (\t)
  var formatted = '', indent= '';
  tab = tab || '\t';
  xml.split(/>\s*</).forEach(function(node) {
      if (node.match( /^\/\w/ )) indent = indent.substring(tab.length); // decrease indent by one 'tab'
      formatted += indent + '<' + node + '>\r\n';
      if (node.match( /^<?\w[^>]*[^\/]$/ )) indent += tab;              // increase indent
  });
  return formatted.substring(1, formatted.length-3);
}

export function lookupDescription(lookup, value) {
  const lookupValue=lookup.find(row=>{return row.value===value});
  if (lookupValue)
  return lookupValue.text;
}

export function objectOrArraytoArray(input) {
  if (Array.isArray(input))
    return input
  else if (typeof input==='object')
    return [input]

}

export function defaultJSONObject(jsonformat)
{
  //list
  if ('type' in jsonformat && jsonformat.type==='array')
    return [defaultJSONObject(jsonformat.arrayof)]
  else if ('type' in jsonformat && jsonformat.type==='object')
    if ('subobjects' in jsonformat)
        return Object.keys(jsonformat.subobjects).reduce((prevValue, subobjectname)=>{
          const subobject=jsonformat.subobjects[subobjectname];
          if (subobject.addbydefault)
            prevValue[subobjectname]=defaultJSONObject(subobject);
          return prevValue;
        }, {})
      else
        return {}
}

export function exporttoJSON(data, filename) {
  const json=JSON.stringify(data, null, 2 )
  var hiddenElement = document.createElement('a');
  hiddenElement.href = 'data:text;charset=utf-8,' + encodeURI(json);
  hiddenElement.target = '_blank';
  hiddenElement.download = filename;
  hiddenElement.click();
}



export function JSONTime(date) {
 
  var hours = date.getHours();
  var minutes= date.getMinutes();
  var seconds = date.getSeconds();

  return ('00'+hours.toString()).slice(-2)+':'+('00'+minutes.toString()).slice(-2)+':'+('00'+seconds.toString()).slice(-2);
}
